import {Pipe, PipeTransform} from '@angular/core';
import {Stock} from '../models/stock';

@Pipe({
    name: 'alphabetical',
    standalone: false
})
export class AlphabeticalPipe implements PipeTransform {

  transform(items: Stock[], char: string): Stock[] {

    if (char.toUpperCase() === 'ALL') {
      return items;
    }

    return items.filter(i => {
        if (i.product.name) {
          if (i.product.name.lastIndexOf(char, 0) === 0) {
            return i;
          }
        }
      }
    );
  }
}
